import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import type { ThreadFilters } from "@productlane/zero/queries"
import { queries } from "@productlane/zero/queries"

import type { InboxState } from "@/lib/states/global-state"
import type { TTL } from "@rocicorp/zero"
import { useAuthData } from "@/lib/zero"
import { closeLoopNotAssignedTo } from "./helpers/inbox-count-filters"

export const useTotalInboxThreadCount = () => {
	const { userId } = useAuthData()
	const closeLoopNotMine = useMemo(
		() => closeLoopNotAssignedTo(userId),
		[userId],
	)

	const { count: newCount } = useThreadCount({ tab: "new" })
	const { count: assignedToMeCount } = useThreadCount({ tab: "my" })
	const { count: closeLoopCount } = useThreadCount({
		tab: "close-loop",
		filters: closeLoopNotMine,
	})

	const count = newCount + assignedToMeCount + closeLoopCount
	return { label: getFormattedThreadCount(count), count }
}

export const useThreadCount = ({
	tab,
	nowMs,
	enabled = true,
	ttl,
	filters,
}: {
	tab: InboxState
	nowMs?: number
	enabled?: boolean
	ttl?: TTL
	filters?: ThreadFilters
}) => {
	const [threads, result] = useQuery(
		queries.threadCount({ tab, nowMs, filters }),
		{ enabled, ttl },
	)

	const count = threads.length
	const text = getFormattedThreadCount(count)

	return { label: text, count, isLoaded: result.type === "complete" }
}

export const getFormattedThreadCount = (count: number, cap = 99): string => {
	return count > cap ? `${cap}+` : count.toString()
}
